import { createActions } from 'redux-actions';

export const actions = createActions({
  ERRORS: {
    HANDLE_API_ERROR: (error) => error,
    HANDLE_AUTH_ERROR: () => ({}),
  },
}).errors;
